import { graphql } from 'gatsby';
import React, { useRef } from 'react';

import { TextArrayProps } from '../../page-components/editorial-page-full-width/editorial-page-full-width';
import EditorialFullWidthTextAndImageBlock, {
  FullWidthTextAndImageProps,
} from '../editorial-full-width-text-and-image-block/editorial-full-width-text-and-image-block';

export interface FullWidthCarouselProps {
  carouselItems: FullWidthTextAndImageProps[];
  topBlock?: boolean;
  textItem?: TextArrayProps[];
}
const EditorialFullWidthCarouselBlock = ({
  topBlock,
  carouselItems,
  textItem,
}: FullWidthCarouselProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={containerRef}
      className={
        'flex w-full snap-x snap-mandatory scroll-p-5 items-start gap-4 overflow-scroll scroll-smooth px-5 scrollbar-hide sm:px-0 ' +
        (topBlock ? 'pt-5 lg:pt-0' : ' ')
      }
    >
      {carouselItems?.map((card, index) => {
        const { body, portraitImage, landscapeImage, cardType } = card;
        return (
          <div
            key={index}
            className="flex w-full min-w-[300px] flex-1 select-none snap-start flex-col-reverse items-center justify-end bg-transparent md:w-0 md:justify-center md:py-0 lg:flex-row "
          >
            <EditorialFullWidthTextAndImageBlock
              cardLink={card.cardLink ? card.cardLink : undefined}
              externalLink={card.externalLink ? card.externalLink : undefined}
              cardType={cardType}
              textItem={textItem ? textItem[index] : undefined}
              body={body ? body : undefined}
              portraitImage={portraitImage ? portraitImage : undefined}
              landscapeImage={landscapeImage ? landscapeImage : undefined}
              topBlock={topBlock}
            />
          </div>
        );
      })}
    </div>
  );
};

export default EditorialFullWidthCarouselBlock;

export const query = graphql`
  fragment BlockEditorialFullWidthCarousel on ContentfulBlockEditorialFullWidthCarousel {
    blocktype: __typename
    id
    carouselItems {
      ...BlockEditorialFullWidthTextAndImage
    }
  }
`;
